import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export default function getEmailContextConfiguration() {
  return new NetworkRequestConfiguration({
    endpoint: 'renters/contexts/email_context',
    method: NetworkRequestConfiguration.Methods.GET,
  });
}
